// components/PublicPageLayout.jsx
import React from "react";

const PublicPageLayout = ({ children }) => {
  return (
    <div className="relative w-full h-screen overflow-hidden flex items-center justify-center bg-subMain">
      {/* Grid Background */}
      <div
        className="absolute inset-0 dark:bg-[linear-gradient(to_right,#e2e8f0_1px,transparent_1px),linear-gradient(to_bottom,#e2e8f0_1px,transparent_1px)] 
      bg-[linear-gradient(to_right,#161616_1px,transparent_1px),linear-gradient(to_bottom,#161616_1px,transparent_1px)] 
      bg-[size:3rem_3rem] 
      [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_110%)] z-0"
      />

      {/* Teal overlay */}
      <div className="absolute inset-0 bg-subMain opacity-60 z-0" />

      {/* Page content */}
      <div className="relative z-10 w-full px-4">{children}</div>
    </div>
  );
};

export default PublicPageLayout;
